module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-left-bottom-stone-path-background.8d28e0cc.png";